import React, { useState } from 'react'
import { Modal, Button } from "react-bootstrap";
import styles from "./AdminModal.module.css";

const AdminModal = ({ showModal, checkAdmin, children }) => {

    const [passwordInput, setpasswordInput] = useState('')
    const [inputError, setinputError] = useState('')
    const [show, setShow] = useState(showModal);

    const handleClose = () => setShow(false);
    const handleChange = (e) => {
        setinputError('');
        setpasswordInput(e.target.value) 
    }
    const checkIsAdmin = () => {
        if (passwordInput) {
            checkAdmin(passwordInput)
            setTimeout(() => {
                handleClose()
            }, 3000);
        } else {
            setinputError("Vous devez saisir le mot de passe")
        }
        // setTimeout(() => {
        //     handleClose()
        // }, 3000);
    }

    return (
        <div className={styles.divModal}>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Auth Admin</Modal.Title>
                </Modal.Header>
                <Modal.Body>Si vous êtes le propriétaire, Identifiez vous, sinon vous pouvez fermer cette Modal !<br />
                    <span style={{ fontWeight: 'bold' }}>NB : Pour permettre de gérer le statut dans le chat</span>
                </Modal.Body>
                <Modal.Body>
                    <input type='password' value={passwordInput} placeholder='Mot de passe Admin'
                        onChange={handleChange}>
                    </input>
                </Modal.Body>
                {inputError && <Modal.Body style={{ color: '#ff0000' }}>{inputError}</Modal.Body>}
                <Modal.Body>{children}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Continuer en visiteur
                    </Button>
                    <Button variant="primary" onClick={checkIsAdmin}>
                        Envoyer
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default AdminModal